import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { formatVND } from "../../constants"
import { pickValue } from "./reportUtils"

// Thin horizontal bar rows: rank (optional), name, value, contribution %
// (optional), and a slim neutral-track bar. Same data shape as the previous
// HBarList (item.value / item.spend / item.score) — only the presentation
// changed (thinner bars, tighter row spacing, clearer value alignment).
const ReportBarList = ({
  items = [],
  color = "info",
  money = true,
  showRank = false,
  showPercent = false,
  limit,
}) => {
  if (items.length === 0) {
    return (
      <MDTypography variant="body2" color="text">
        No data for the current filters.
      </MDTypography>
    )
  }

  const list = limit ? items.slice(0, limit) : items
  const max = Math.max(1, ...list.map(pickValue))
  const total = list.reduce((sum, i) => sum + pickValue(i), 0)

  return (
    <MDBox>
      {list.map((item, idx) => {
        const v = pickValue(item)
        const pct = total > 0 ? (v / total) * 100 : 0
        return (
          <MDBox
            key={item.name}
            display="flex"
            alignItems="center"
            gap={1.25}
            py={1}
            sx={idx < list.length - 1 ? { borderBottom: "1px solid", borderColor: "grey.100" } : undefined}
          >
            {showRank && (
              <MDTypography
                variant="caption"
                color="text"
                fontWeight="medium"
                sx={{ width: "1.1rem", flexShrink: 0 }}
              >
                {idx + 1}
              </MDTypography>
            )}
            <MDBox sx={{ flex: 1, minWidth: 0 }}>
              <MDBox display="flex" justifyContent="space-between" alignItems="baseline" gap={1} mb={0.5}>
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                >
                  {item.name}
                </MDTypography>
                <MDBox display="flex" alignItems="baseline" gap={1} sx={{ flexShrink: 0 }}>
                  <MDTypography variant="caption" fontWeight="bold">
                    {money ? formatVND(v) : v}
                  </MDTypography>
                  {showPercent && (
                    <MDTypography variant="caption" color="text" sx={{ minWidth: "2.6rem", textAlign: "right" }}>
                      {pct.toFixed(1)}%
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox width="100%" height="0.375rem" borderRadius="md" bgColor="grey-100" overflow="hidden">
                <MDBox width={`${(v / max) * 100}%`} height="100%" bgColor={color} borderRadius="md" />
              </MDBox>
            </MDBox>
          </MDBox>
        )
      })}
    </MDBox>
  )
}

export default ReportBarList
